module.exports = __webpack_public_path__ + "img/slide14.f04e7cf0.png";